import React, { memo } from 'react';
import interpolate from '../../../utils/interpolate';
import { Typography } from '../../../foundations/typography';
import styles from './MessageText.module.scss';
export var MessageText = memo(function (_a) {
    var _b = _a.isHtml, isHtml = _b === void 0 ? false : _b, params = _a.params, _c = _a.text, text = _c === void 0 ? [] : _c;
    return (React.createElement("div", { className: styles.messageText }, text.map(function (message) {
        var interpolatedMessage = params ? interpolate(message, params) : message;
        return isHtml ? (React.createElement(Typography, { key: String(message), 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: { __html: interpolatedMessage } })) : (React.createElement(Typography, { key: String(message) }, interpolatedMessage));
    })));
});
MessageText.displayName = 'MessageText';
//# sourceMappingURL=MessageText.js.map